"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.Tooltip = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children,
      content = props.content,
      tooltipPosition = props.tooltipPosition,
      maxWidth = props.maxWidth,
      icon = props.icon;

  var _a = React.useState(false),
      isHover = _a[0],
      setHover = _a[1];

  var _b = React.useState(0),
      containerHeight = _b[0],
      setContainerHeight = _b[1];

  var tooltipRef = React.useRef();
  React.useEffect(function () {
    if (tooltipRef && tooltipRef.current && !!tooltipRef.current.clientHeight) {
      return setContainerHeight(tooltipRef.current.clientHeight);
    }
  });
  var tooltipContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t"], ["\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t"])));
  var tooltipHoverContainer = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tdisplay: ", ";\n\t\tposition: absolute;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\t", ";\n\t\t", ";\n\t\tbackground: ", ";\n\t\tborder-radius: 0.5em;\n\t\tline-height: 150%;\n\t\tpadding: 0.75em 1em;\n\t\tcolor: ", ";\n\t\tborder: solid 1px ", ";\n\t\tfont-size: 0.75em;\n\t\t", ";\n\t\tz-index: 100;\n\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tmargin-top: ", ";\n\t\t\tbackground: ", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\tmargin-left: calc(50% - 1em);\n\t\t\tcontent: '';\n\t\t\tborder-radius: 2px;\n\t\t\twidth: 1em;\n\t\t\theight: 1em;\n\t\t\ttransform: rotate(45deg);\n\t\t}\n\t"], ["\n\t\tdisplay: ", ";\n\t\tposition: absolute;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\t", ";\n\t\t", ";\n\t\tbackground: ", ";\n\t\tborder-radius: 0.5em;\n\t\tline-height: 150%;\n\t\tpadding: 0.75em 1em;\n\t\tcolor: ", ";\n\t\tborder: solid 1px ", ";\n\t\tfont-size: 0.75em;\n\t\t", ";\n\t\tz-index: 100;\n\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tmargin-top: ", ";\n\t\t\tbackground: ", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\n\t\t\tmargin-left: calc(50% - 1em);\n\t\t\tcontent: '';\n\t\t\tborder-radius: 2px;\n\t\t\twidth: 1em;\n\t\t\theight: 1em;\n\t\t\ttransform: rotate(45deg);\n\t\t}\n\t"])), isHover ? 'flex' : 'none', tooltipPosition === 'top' && "margin-bottom: calc(" + containerHeight + "px + 40px);", tooltipPosition === 'bottom' && "margin-top: calc(" + containerHeight + "px + 40px);", foundation_1.colors.white, foundation_1.colors.secondary.grey, foundation_1.colors.graphical.strokes, maxWidth && "max-width:" + maxWidth + ";", tooltipPosition === 'top' ? "calc(" + containerHeight + "px - 1.25em);" : '-1.30em', foundation_1.colors.white, tooltipPosition === 'bottom' && "border-top: solid 1px " + foundation_1.colors.graphical.strokes + ";", tooltipPosition === 'bottom' && "border-left: solid 1px " + foundation_1.colors.graphical.strokes + ";", tooltipPosition === 'top' && "border-bottom: solid 1px " + foundation_1.colors.graphical.strokes + ";", tooltipPosition === 'top' && "border-right: solid 1px " + foundation_1.colors.graphical.strokes + ";");
  var tooltipTextContainer = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tcursor: pointer;\n\t"], ["\n\t\twidth: 100%;\n\t\tcursor: pointer;\n\t"])));
  var iconStyle = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\twidth: 2em;\n\t"], ["\n\t\twidth: 2em;\n\t"])));
  var contentStyle = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\twidth: calc(100% - 2em);\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t"], ["\n\t\twidth: calc(100% - 2em);\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\ttext-align: left;\n\t"])));

  var setHoverStatus = function setHoverStatus(value) {
    if (value && !isHover) {
      setHover(true);
    } else {
      if (isHover) {
        setHover(false);
      }
    }
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tooltipContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    ref: tooltipRef,
    css: tooltipHoverContainer
  }, icon && (0, _core.jsx)(lseds_1.lseds.div, {
    css: iconStyle
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: icon
  })), (0, _core.jsx)(lseds_1.lseds.div, {
    css: contentStyle
  }, content)), (0, _core.jsx)(lseds_1.lseds.div, {
    onMouseEnter: function onMouseEnter() {
      return setHoverStatus(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverStatus(false);
    },
    ref: ref,
    css: tooltipTextContainer
  }, children));
});

if (utils_1.isDev) {
  exports.Tooltip.displayName = 'Tooltip';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;